import { createApi } from "@reduxjs/toolkit/query/react"
import axiosBaseQuery from "../../../config/service"

const API_BASE_PATH = '/jaaga/api'

export const authApiService = createApi({
   reducerPath: "authApiService",
   baseQuery: axiosBaseQuery(),
   endpoints: (builder) => ({
      sendOTP: builder.mutation({
         query: (data) => ({
            url: `${API_BASE_PATH}/auth/otp/send`,
            method: "POST",
            body: data
         }),
         invalidatesTags: ["sendOTP"]
      }),
      resendOTP: builder.mutation({
         query: (data) => ({
            url: `${API_BASE_PATH}/auth/otp/resend`,
            method: "POST",
            body: data
         }),
         invalidatesTags: ["resendOTP"]
      }),
      verifyOTP: builder.mutation({
         query: (data) => ({
            url: `${API_BASE_PATH}/auth/otp/verify`,
            method: "POST",
            body: data
         }),
         invalidatesTags: ["verifyOTP"]
      }),
   })
})

export const { useSendOTPMutation, useResendOTPMutation, useVerifyOTPMutation } = authApiService

